import React from 'react';

export interface TextAreaFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  id?: string;
  disabled?: boolean;
}

/**
 * Reusable textarea field component
 */
export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  label,
  value,
  onChange,
  error,
  placeholder,
  required = false,
  rows = 4,
  id,
  disabled = false,
}) => {
  const fieldId = id || `textarea-field-${label.toLowerCase().replace(/\s+/g, '-')}`;
  const errorId = `${fieldId}-error`;

  return (
    <div style={{ marginBottom: '15px' }}>
      <label 
        htmlFor={fieldId} 
        style={{ 
          display: 'block', 
          marginBottom: '5px', 
          fontWeight: required ? 'bold' : 'normal' 
        }}
      >
        {label}
        {required && <span style={{ color: 'red', marginLeft: '4px' }} aria-label="required">*</span>}
      </label>
      <textarea
        id={fieldId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? errorId : undefined}
        style={{
          width: '100%',
          padding: '8px',
          fontSize: '14px',
          border: error ? '1px solid #dc3545' : '1px solid #ccc',
          borderRadius: '4px',
          fontFamily: 'inherit',
          resize: 'vertical',
          boxSizing: 'border-box',
        }}
      />
      {error && (
        <div
          id={errorId}
          role="alert"
          style={{
            color: '#dc3545',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

